import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Label, Input, Col, Row, Container } from 'reactstrap';
import { Doughnut } from 'react-chartjs-2';
import numeral from 'numeral';
import _ from 'lodash';
import api from '../../../api';
import BusinessPartnerObject from '../../../components/BusinessPartnerObject';

import './index.css';

export default class UserManagement extends React.Component {
    constructor(props) {
        super(props);
        let externalContentId = null;
        if (this.props.match.params.external_content_id) {
            externalContentId = this.props.match.params.external_content_id;
        }
        this.state = {
            searchKeyword: '',
            businessPartners: [],
            searchResultCount: 0,
            isSearching: false,
            currentUser: {
                is_system_admin: 0,
            },
            newUser: {
                email: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                is_system_admin: 0
            },
            isCreatingNewUser: false,
            externalContentId,
            content: null,
            metabaseToken: '',
        }
    }
    componentWillMount() {
        this.getCurrentUser();
    }
    async componentDidMount() {
        document.title = "Content Analysis";
        const { externalContentId } = this.state;
        if (externalContentId) {
            await this.getCurrentUser();
            await this.getContentSentiment();
        }
        await this.getMetabaseToken();
    }
    getMetabaseToken() {
        const { externalContentId } = this.state;
        let uri = 'metabase/token';

        if (externalContentId) {
            uri = `${uri}?thread_id=${externalContentId}`;
        }
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({
                        metabaseToken: response.token,
                        metabaseIframeUrl: response.iframeUrl,
                    });
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: 'user/me',
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ currentUser: response.user })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getContentSentiment() {
        this.getMetabaseToken();
        const { externalContentId } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `content/${externalContentId}/sentiment`,
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ content: response });
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    // renderSentimentPieChart() {
    //     const { content } = this.state;
    //     const totalComment = content.sentiment.positive + content.sentiment.negative + content.sentiment.neutral;
    //     const pctPositive = content.sentiment.positive / totalComment;
    //     const pctNegative = content.sentiment.negative / totalComment;
    //     const pctNeutral = content.sentiment.neutral / totalComment;
        
    //     const labelPositive = `Positive (${numeral(pctPositive).format('0.0%')}`;
    //     const labelNegative = `Negative (${numeral(pctNegative).format('0.0%')}`;
    //     const labelNeutral = `Neutral (${numeral(pctNeutral).format('0.0%')}`;
    //     return (
    //         <Doughnut
    //             data={{
    //                 labels: [labelPositive, labelNegative, labelNeutral],
    //                 datasets: [
    //                     {
    //                         type: 'pie',
    //                         label: 'Phân loại sentiment',
    //                         borderWidth: 1,
    //                         fill: false,
    //                         backgroundColor: ['#00e08a', '#ff0055', '#dbdbdb'],
    //                         data: [pctPositive, pctNegative, pctNeutral],
    //                     },
    //                 ],
    //             }}
    //             options={{
    //                 responsive: true,
    //                 legend: {
    //                     position: 'right',
    //                     display: true,
    //                 },
    //             }}
    //         />
    //     )
    // }
    render() {
        const {
            currentUser,
            externalContentId,
            content,
            metabaseToken,
            metabaseIframeUrl,
        } = this.state;
        const isCurrentUserAdmin = currentUser.is_system_admin;

        if (isCurrentUserAdmin <= 0) return null;
        return (
            <div>
                <Row>
                    <Col xs={12}>
                        <h1>Content Analysis</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <FormGroup>
                            <Label>External Content ID</Label>
                            <Input
                                type="text"
                                onChange={(e) => this.setState({ externalContentId: e.target.value })}
                                value={externalContentId}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Button
                                color="success"
                                onClick={() => this.getContentSentiment()}
                            >
                                Get metrics
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
                {(content && content.detail && content.detail.external_content_id && content.sentiment) &&
                    <div>
                        <Row className="metrics-page-group">
                            <Col xs={12}>
                                <h3>{content.detail.title}</h3>
                                <a target="_blank" href={`https://tinhte.vn/thread/${content.external_content_id}`}>Xem nội dung</a>
                            </Col>
                        </Row>
                        {/* <Row className="metrics-group">
                            <Col xs={12}>
                                <p className="metrics-group-name">Phân tích cảm nghĩ</p>
                                <p>Phân tích cảm xúc tích cực, tiêu cực, hoặc trung lập, dựa trên comment của người dùng</p>
                            </Col>
                            <Col xs={12} sm={6}>
                                <div>
                                    <div className="sentiment-row"><div className="sentiment-badge positive">{content.sentiment.positive}</div> Positive 🥰</div>
                                    <div className="sentiment-row"><div className="sentiment-badge negative">{content.sentiment.negative}</div> Negative 😡</div>
                                    <div className="sentiment-row"><div className="sentiment-badge neutral">{content.sentiment.neutral}</div> Neutral 😀</div>
                                </div>
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderSentimentPieChart()}
                            </Col>
                        </Row> */}
                    </div>
                }
                {metabaseIframeUrl &&
                    <Row>
                        <Col xs="12">
                            <iframe
                                src={metabaseIframeUrl}
                                frameBorder="0"
                                allowTransparency
                                className="metabase-iframe"
                            />
                        </Col>
                    </Row>
                }
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Analytics/ContentAnalysis/index.js